InlineVariations = window.InlineVariations ?= {}
InlineVariations.Views ?= {}

InlineVariations.Views.NativeDropdownTrait = Backbone.View.extend
  inlineTrait: '.inline-variation-trait'

  events:
    'change .inline-variation-trait': 'traitValueSelection'

  initialize: ->
    @$inlineNativeTrait = @$el.find @inlineTrait

    @listenTo @model, 'change:selectedTraitValue', @setTraitValue

    @processTraitValues()

  processTraitValues: ->
    for value in @model.get 'values'
      value.$el = @$el.find "##{value.id}"

  traitValueSelection: (e) ->
    @model.setSelectedTraitValueByName $(e.currentTarget).val()
    @model.collection.view.render()

  getSelectedTrait: (id) ->
    if id
      _.findWhere @model.get('values'), {id}
    else
      _.first @model.get 'values'

  setTraitValue: ->
    @getSelectedTrait(@model.get('selectedTraitValueId')).$el.prop 'selected', true

  showErrorMessages: ->
    return if @model.get 'selectedTraitValue'

    @$el.addClass 'error'
    @$inlineNativeTrait.addClass 'error'

  hideErrorMessages: ->
    @$el.removeClass 'error'
    @$inlineNativeTrait.removeClass 'error'

  toggleSoldOut: (traitValue, isSoldOut) ->
    traitValue.$el.prop 'disabled', isSoldOut

  closeDropdown: ->

module.exports = InlineVariations.Views.NativeDropdownTrait
